
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/product/[tutorialId]",
      function () {
        return require("private-next-pages/[publicId]/product/[tutorialId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/product/[tutorialId]"])
      });
    }
  